import React from 'react';
import { NavLink } from 'react-router-dom';

function Navbar({ isAdmin }) {
  return (
    <nav className="navbar">
      <NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''}>Music</NavLink>
      <NavLink to="/poetry" className={({ isActive }) => isActive ? 'active' : ''}>Poetry</NavLink>
      <NavLink to="/blog" className={({ isActive }) => isActive ? 'active' : ''}>Blog</NavLink>
      <NavLink to="/books" className={({ isActive }) => isActive ? 'active' : ''}>Books</NavLink>
      {isAdmin && (
        <NavLink to="/analytics" className={({ isActive }) => isActive ? 'active' : ''}>Analytics</NavLink>
      )}
    </nav>
  );
}

export default Navbar;
